export namespace IRecordRawAssignmentsRequest {
  export namespace IRawAssignment {
    /**
     * Return an instance of IRawAssignment with the provided fields. Any field not
     * listed will be populated with an empty value (an empty array,
     * or undefined, whichever is valid for the type of the value.)
     */
    export const build = (partial?: Partial<IRawAssignment>): IRawAssignment =>
      ({
        ...(partial ?? {}),
      }) as IRawAssignment;
  }

  export interface IRawAssignment {
    /**
     * The identifier of the subject being experimented on. This is frequently something like user, brand, retailer, or
     * session token.
     */
    identifier: string | undefined;
    /**
     * The name of the setting that has been assigned.
     */
    setting_name: string | undefined;
    /**
     * The name of the segment/audience that is getting assigned. For some settings multiple audiences can be tested on
     * independently.
     */
    experiment_name: string | undefined;
    /**
     * The name of the bucket in the current experiment that has been selected. This is *not* the value - it's the name
     * of the bucket containing the value. Values can be very complex and are not included as part of the assignment.
     */
    bucket_name: string | undefined;
    /**
     * Timestamp indicating when this assignment was created. Milliseconds since the epoch.
     * @protobufOption (faire.protobuf.validation) = TIMESTAMP_MILLIS
     */
    created_at: number | undefined;
    /**
     * Whether or not this assignment is in pre-test mode. Pretest assignments should normally be excluded from real
     * analysis. They are a testing phase to make sure the bucket and audience configurations are correct before
     * proceeding on to the fully fledged experiment.
     */
    is_pretest: boolean | undefined;
  }

  /**
   * Return an instance of IRecordRawAssignmentsRequest with the provided fields. Any field not
   * listed will be populated with an empty value (an empty array,
   * or undefined, whichever is valid for the type of the value.)
   */
  export const build = (
    partial?: Partial<IRecordRawAssignmentsRequest>
  ): IRecordRawAssignmentsRequest =>
    ({
      assignments: [],
      ...(partial ?? {}),
    }) as IRecordRawAssignmentsRequest;
}

export interface IRecordRawAssignmentsRequest {
  assignments: Array<IRecordRawAssignmentsRequest.IRawAssignment>;
}
